import { useEffect, useState } from 'react';
import { laboratoryClient } from 'page-editor-ui/utils/laboratoryUtil';
export const useExperiments = () => {
  const [experiments, setExperiments] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      setExperiments(treatments);
      setLoading(false);
    });
  }, []);
  return {
    experiments,
    loading
  };
};